import { getCurrentLocale } from "./locale";

const CUSTOMER_TYPE_ALIASES = {
  sl: "senior_living",
  seniorliving: "senior_living",
  senior_living: "senior_living",
  hc: "home_care",
  homecare: "home_care",
  home_care: "home_care",
  pcp: "primary_care",
  primarycare: "primary_care",
  primary_care: "primary_care",
  rehab: "rehab",
  rehabilitation: "rehab",
  pharmacy: "pharmacy",
  fp: "pharmacy",
  familiprix: "pharmacy",
  cognitive: "cognitive",
};

const PERSON_TERMINOLOGY = {
  senior_living: { singular: "Resident", plural: "Residents" },
  home_care: { singular: "Client", plural: "Clients" },
  rehab: { singular: "Patient", plural: "Patients" },
  primary_care: { singular: "Patient", plural: "Patients" },
  pharmacy: { singular: "Patient", plural: "Patients" },
  cognitive: { singular: "Patient", plural: "Patients" },
};

const JA_PERSON_TERMINOLOGY = {
  senior_living: { singular: "入居者", plural: "入居者" },
  home_care: { singular: "利用者", plural: "利用者" },
  rehab: { singular: "患者", plural: "患者" },
  primary_care: { singular: "患者", plural: "患者" },
  pharmacy: { singular: "患者", plural: "患者" },
  cognitive: { singular: "患者", plural: "患者" },
};

const ZH_PERSON_TERMINOLOGY = {
  senior_living: { singular: "住户", plural: "住户" },
  home_care: { singular: "客户", plural: "客户" },
  rehab: { singular: "患者", plural: "患者" },
  primary_care: { singular: "患者", plural: "患者" },
  pharmacy: { singular: "患者", plural: "患者" },
  cognitive: { singular: "患者", plural: "患者" },
};

const LOCALIZED_TERMINOLOGY = {
  ja: JA_PERSON_TERMINOLOGY,
  zh: ZH_PERSON_TERMINOLOGY,
  fr: {
    senior_living: { singular: "Résident", plural: "Résidents" },
    home_care: { singular: "Client", plural: "Clients" },
    ...Object.fromEntries(
      ["rehab", "primary_care", "pharmacy", "cognitive"].map((type) => [
        type,
        { singular: "Patient", plural: "Patients" },
      ]),
    ),
  },
  es: {
    senior_living: { singular: "Residente", plural: "Residentes" },
    home_care: { singular: "Cliente", plural: "Clientes" },
    ...Object.fromEntries(
      ["rehab", "primary_care", "pharmacy", "cognitive"].map((type) => [
        type,
        { singular: "Paciente", plural: "Pacientes" },
      ]),
    ),
  },
  ru: {
    senior_living: { singular: "Резидент", plural: "Резиденты" },
    home_care: { singular: "Клиент", plural: "Клиенты" },
    ...Object.fromEntries(
      ["rehab", "primary_care", "pharmacy", "cognitive"].map((type) => [
        type,
        { singular: "Пациент", plural: "Пациенты" },
      ]),
    ),
  },
};

const FALLBACK_TERMINOLOGY = {
  en: { singular: "Test Person", plural: "Test Persons" },
  ja: { singular: "テスト対象者", plural: "テスト対象者" },
  zh: { singular: "测试人员", plural: "测试人员" },
  fr: { singular: "Personne test", plural: "Personnes test" },
  es: { singular: "Persona de prueba", plural: "Personas de prueba" },
  ru: { singular: "Участник теста", plural: "Участники теста" },
};

const getStoredAccount = () => {
  try {
    return JSON.parse(sessionStorage.getItem("staffDetails") || "null");
  } catch {
    return null;
  }
};

export const resolveCustomerType = (account) => {
  const source = account || getStoredAccount();
  const raw =
    source?.customer_type ||
    source?.customerType ||
    source?.tenant_type ||
    source?.tenantType ||
    source?.careSetting ||
    source?.tenant ||
    source?.metadata?.customer_type ||
    source?.metadata?.customerType ||
    "";
  const normalized = String(raw)
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");
  return CUSTOMER_TYPE_ALIASES[normalized] || normalized;
};

export const getPersonTerminology = (account, locale = getCurrentLocale()) => {
  const customerType = resolveCustomerType(account);
  const localized = LOCALIZED_TERMINOLOGY[locale];
  const preserveCase = ["ja", "zh"].includes(locale);
  const terminology = localized || PERSON_TERMINOLOGY;
  const labels =
    terminology[customerType] ||
    FALLBACK_TERMINOLOGY[locale] ||
    FALLBACK_TERMINOLOGY.en;

  return {
    ...labels,
    singularLower: preserveCase
      ? labels.singular
      : labels.singular.toLowerCase(),
    pluralLower: preserveCase ? labels.plural : labels.plural.toLowerCase(),
  };
};
